(function () {
  var sections = document.querySelectorAll('[data-flow-listicle]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    initDate(section);
    initTimer(section);
    initStickyCta(section);
    initCtaTracking(section);
  });

  function initDate(section) {
    var dateEl = section.querySelector('[data-flow-listicle-date]');
    if (!dateEl) return;

    var formatter = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
    dateEl.textContent = formatter.format(new Date());
  }

  function initTimer(section) {
    var timers = Array.prototype.slice.call(
      section.querySelectorAll('[data-flow-listicle-timer], [data-flow-listicle-offer-timer]')
    );
    if (!timers.length) return;

    var duration =
      toNumber(section.dataset.timerHours) * 60 * 60 +
      toNumber(section.dataset.timerMinutes) * 60 +
      toNumber(section.dataset.timerSeconds);

    if (duration <= 0) return;

    var storageKey = 'flow_listicle_timer_' + (section.dataset.sectionId || 'default');
    var endTime = readStoredEndTime(storageKey);
    var now = Date.now();

    if (!endTime || endTime <= now) {
      endTime = now + duration * 1000;
      try {
        window.localStorage.setItem(storageKey, String(endTime));
      } catch (error) {
        endTime = now + duration * 1000;
      }
    }

    function tick() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

      if (remaining <= 0) {
        endTime = Date.now() + duration * 1000;
        try {
          window.localStorage.setItem(storageKey, String(endTime));
        } catch (error) {
          // The timer can continue without storage.
        }
        remaining = duration;
      }

      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      var text = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

      timers.forEach(function (timer) {
        var hoursEl = timer.querySelector('[data-timer-hours]');
        var minutesEl = timer.querySelector('[data-timer-minutes]');
        var secondsEl = timer.querySelector('[data-timer-seconds]');

        if (hoursEl || minutesEl || secondsEl) {
          if (hoursEl) hoursEl.textContent = pad(hours);
          if (minutesEl) minutesEl.textContent = pad(minutes);
          if (secondsEl) secondsEl.textContent = pad(seconds);
        } else {
          timer.textContent = text;
        }
      });
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initStickyCta(section) {
    var sticky = section.querySelector('[data-flow-listicle-sticky]');
    if (!sticky) return;

    var link = sticky.querySelector('a');
    var reasons = section.querySelector('[data-flow-listicle-reasons]');
    var offer = section.querySelector('.flow-listicle__offer');
    var showOffset = reasons ? reasons.offsetTop : 560;
    var hideOffset = offer ? offer.offsetTop - window.innerHeight * 0.65 : Number.POSITIVE_INFINITY;
    var ticking = false;

    function updateOffsets() {
      showOffset = reasons ? reasons.offsetTop : 560;
      hideOffset = offer ? offer.offsetTop - window.innerHeight * 0.65 : Number.POSITIVE_INFINITY;
      update();
    }

    function update() {
      ticking = false;
      var shouldShow = window.scrollY > showOffset && window.scrollY < hideOffset;
      sticky.classList.toggle('is-active', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (link) link.tabIndex = shouldShow ? 0 : -1;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    updateOffsets();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', updateOffsets);
    window.addEventListener('load', updateOffsets);
  }

  function initCtaTracking(section) {
    var links = section.querySelectorAll('[data-flow-listicle-cta]');
    if (!links.length) return;

    var params = new URLSearchParams(window.location.search);
    var passthroughKeys = ['gclid', 'fbclid', 'msclkid'];

    links.forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);

        params.forEach(function (value, key) {
          if (key.indexOf('utm_') === 0 || passthroughKeys.indexOf(key) !== -1) {
            url.searchParams.set(key, value);
          }
        });

        if (url.origin === window.location.origin) {
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } else {
          link.setAttribute('href', url.toString());
        }
      } catch (error) {
        // Leave malformed URLs unchanged so theme editing is not blocked.
      }
    });
  }

  function readStoredEndTime(storageKey) {
    try {
      var stored = Number.parseInt(window.localStorage.getItem(storageKey), 10);
      return Number.isFinite(stored) ? stored : null;
    } catch (error) {
      return null;
    }
  }

  function toNumber(value) {
    var number = Number.parseInt(value, 10);
    return Number.isFinite(number) ? number : 0;
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }
})();
